"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TICKET_CATEGORIES = exports.COMPLETED_TICKET_STATUSES = exports.INACTIVE_TICKET_STATUSES = exports.normalizeTicketStatusKey = exports.TURN_PROGRESS_COMPLETED_STATUSES = exports.TURN_PROGRESS_IN_PROGRESS_STATUSES = exports.TURN_PROGRESS_CANCELED_STATUSES = exports.OPEN_TURN_OS_TICKET_STATUSES = exports.TURN_OS_TICKET_STATUSES = exports.TICKET_EXTERNAL_SOURCES = exports.TICKET_TYPES = void 0;
const latchel_1 = require("./latchel");
exports.TICKET_TYPES = {
    TURN: 'turn',
    TURN_OI: 'turn_oi',
    DISPOSITION: 'disposition',
    DISPOSITION_INSPECTION: 'disposition_inspection',
    DISPOSITION_OI: 'disposition_oi',
    REHAB: 'rehab',
    MAINTENANCE: 'maintenance'
};
exports.TICKET_EXTERNAL_SOURCES = {
    LATCHEL: 'latchel',
    TURN_OS: 'turn_os',
    // Reserved for a future Mason mirror sync; no writer exists yet.
    MASON: 'mason'
};
// Native statuses for turn_os tickets. Lowercase on rows and on the wire;
// Latchel rows keep their Title Case vocabulary (see ./latchel).
exports.TURN_OS_TICKET_STATUSES = {
    DISPATCHED: 'dispatched',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    CANCELED: 'canceled'
};
// A ticket is "open" (mutable dispatch state) only in these statuses.
exports.OPEN_TURN_OS_TICKET_STATUSES = new Set([
    exports.TURN_OS_TICKET_STATUSES.DISPATCHED,
    exports.TURN_OS_TICKET_STATUSES.IN_PROGRESS
]);
// Dedicated project-progress vocabulary. Keep these narrower than the shared
// inactive/completed arrays below: the Turn OS rollup intentionally recognizes
// only its canonical lifecycle states plus the legacy cancellation spelling.
exports.TURN_PROGRESS_CANCELED_STATUSES = ['canceled', 'cancelled'];
exports.TURN_PROGRESS_IN_PROGRESS_STATUSES = ['in_progress'];
exports.TURN_PROGRESS_COMPLETED_STATUSES = ['completed'];
const normalizeTicketStatusKey = (value) => String(value).trim().toLowerCase();
exports.normalizeTicketStatusKey = normalizeTicketStatusKey;
// Terminal statuses across every ticket source. INACTIVE_LATCHEL_STATUSES is
// Title Case and compared case-sensitively by legacy consumers, so filters that
// must classify turn_os rows too need this union instead.
exports.INACTIVE_TICKET_STATUSES = [
    ...latchel_1.INACTIVE_LATCHEL_STATUSES,
    exports.TURN_OS_TICKET_STATUSES.COMPLETED,
    exports.TURN_OS_TICKET_STATUSES.CANCELED
];
// Completed (not canceled) statuses across both vocabularies, for
// "Past"/"Completed"-style views that must see both sources.
exports.COMPLETED_TICKET_STATUSES = [
    latchel_1.LATCHEL_STATUSES.COMPLETED,
    exports.TURN_OS_TICKET_STATUSES.COMPLETED
];
exports.TICKET_CATEGORIES = {
    REKEY: 'rekey',
    PAINTING: 'painting',
    SECURITY_INSTALL: 'security_install',
    SECURITY_SYSTEM_REMOVAL: 'security_system_removal',
    MOVE_OUT_INSPECTION: 'move_out_inspection',
    QC_INSPECTION: 'qc_inspection',
    SNOW_REMOVAL: 'snow_removal',
    LANDSCAPING: 'landscaping',
    TREE_REMOVAL: 'tree_removal',
    ROOF: 'roof',
    CLEANING: 'cleaning',
    HANDYMAN: 'handyman',
    PLUMBING: 'plumbing',
    ELECTRICAL: 'electrical',
    TRASH_REMOVAL: 'trash_removal',
    APPLIANCES: 'appliances',
    COUNTERTOPS: 'countertops',
    HVAC: 'hvac',
    PEST_CONTROL: 'pest_control',
    OCCUPANCY_INSPECTION: 'occupancy_inspection',
    MISC: 'misc'
};
